import React from "react";
import styles from "../../styles/components/basicForm.module.scss";
import Icons from "../../public/assets/svg";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
// import Router from "next/router";
import DropDown from "../listWithoutcheck";
import _get from "lodash/get";
import { useDispatch } from "react-redux";

function index(props) {
  //console.log(props, "props at dropdown in edit user");
  let notRequired=['Area','Sub Area','MCO','Lead Platform']
  const dispatch = useDispatch();
  let inputprops = {
    placeholder: "DD-MM-YYYY",
    readOnly : true
  };

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  props.data.map((item) => {
    if (item.field_label == "Comments From Stakeholders") {
      item.value = "commentsFromStakeHolder";
    } else if (item.field_label == "EL") {
      item.value = "el";
    } else if (item.field_label == "MCO") {
      item.value = "mco";
    } else if (item.field_label == "SPOC") {
      item.value = "spoc";
    } else {
      item.value = camelize(item.field_label);
    }
  });

  let initialStates = {};
  let dropDownsInitialStates = {};
  let requiredFields = [];
  let relatedDropdownToSet = {};

  // nested dropdown
  props.data.map((item) => {
    if (
      item.field_input_type == "Related Dropdown" &&
      item.field_related_dropdown.length > 0
    ) {
      let fieldOptions = [];
      item.field_dropdown_option_component.map((item) => {
        fieldOptions = [...fieldOptions, ...item.field_options];
      });
    }
  });

  // intial states setup
  props.data.map((item) => {
    initialStates[item.value] = "";

    if (
      item.field_input_type == "Dropdown" ||
      item.field_input_type == "Related Dropdown"
    ) {
      dropDownsInitialStates[item.value] = false;
    }
    if (item.field_required == "1") {
      if(!props.notRequired.includes(item.field_label))
      requiredFields.push(item.value);
    }
  });

  props.data.map((item) => {
    if (item.field_input_type == "Related Dropdown") {
      relatedDropdownToSet[item.value] = item.field_dropdown_option_component;
    }
  });

  // states
  const [relatedDropdowns, setRelatedDropdowns] = React.useState(relatedDropdownToSet);
  const [state, setState] = React.useState(initialStates);
  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );
  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [value, setValue] = React.useState("")

  // related dropdowns initial setup
//   React.useEffect(() => {
    
    
//     console.log(relatedDropdownToSet, "relatedDropdownToSet");
//     setRelatedDropdowns();
//   }, []);

  // handling input values

  // text input changes
  const inputChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  React.useEffect(() => {
    //console.log(state, "state in form3")
 }, [state])
  // dropdown open close
  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
    //console.log(relatedDropdowns,"relatedDropdowns");
    props.data.map((item)=>{
      
      if(props.formType == "userCreateData" || props.formType == "userAccessEdit"){
      if(value == ""){
      if(item.field_related_dropdown != ""){
        let reall = relatedDropdowns
        for (let i in reall){
            delete reall[i].nowValues
        }
        setRelatedDropdowns({...reall})
      }
    }
  }
})
  };

  // dropdown value selected
  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    // debugger

    setValue(value)
     if (value == "None") {
       if (dropdownParent == "country") {
         setState({ ...state, [dropdownParent]: [] });
       } else {
        let newState = state
        delete newState[dropdownParent];
        setState({...newState})
       }

       setDropdownState(dropDownsInitialStates);
     }
     else {

     
      let newState = state;        
     if (haveRelated) {
      
       delete newState[haveRelated];
       let relatedDropdownsToChange = relatedDropdowns
      props.data.map((item, index) => {
        if (item.value == haveRelated) {
          
          if (
            camelize(item.field_related_dropdown) != null &&
            camelize(item.field_related_dropdown).length > 0
          ) {
            //  let newerState = state
           
              delete newState[camelize(item.field_related_dropdown)];
              delete relatedDropdownsToChange[camelize(item.field_related_dropdown)].nowValues
            
          }
        
        }
      });

      
      const selectedRelatedDropdown = relatedDropdownsToChange[haveRelated];

      selectedRelatedDropdown.nowValues = selectedRelatedDropdown.filter(
        (item) => item.field_title == value
      )[0].field_options;

      setRelatedDropdowns({...relatedDropdownsToChange, [haveRelated] : selectedRelatedDropdown})

    }
    setDropdownState({...dropDownsInitialStates});
    setState({ ...newState, [dropdownParent]: value });
    if (props.params == "approval") {
      props.sendFormValues({
        ...newState,
        [dropdownParent]: value,
      });
    }
    if (props.formType == "approval") {
      if (dropdownParent == "1.PleaseSelectTheProcessArea") {
        props.sendDataToApproval({
          subProcess: state["1.PleaseSelectTheSub-ProcessArea"],
          process: value,
        });
      } else {
        props.sendDataToApproval({
          process: state["1.PleaseSelectTheProcessArea"],
          subProcess: value,
        });
      }
    }
  }
  };

  // date selected
  const handleDate = (date, parent) => {
    if (typeof date == "object") {
      var bigDate = date._d;
      var dd = String(bigDate.getDate()).padStart(2, "0");
      var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = bigDate.getFullYear();
      const myDate = dd + "-" + mm + "-" + yyyy;

      setState({ ...state, [parent]: myDate });
    } else {
      setState({ ...state, [parent]: date._d });
    }
  };

  // send state to parent
  React.useEffect(() => {
    if (props.getFormValues == true) {
       let moveAhead = true;
       //console.log("required Fields", requiredFields);

       for (let i in requiredFields) {
         if (
          state[requiredFields[i]] == "" ||
          state[requiredFields[i]] == false ||
          state[requiredFields[i]] === undefined ||
          state[requiredFields[i]] == undefined||
          state[requiredFields[i]] == "undefined"||
          state[requiredFields[i]] == null
         ) {
           moveAhead = false;
           break;
         }
       }
       if (moveAhead == true) {
         props.sendFormValues(state);
         setInvalidFlag(false);
       } else {
         if (props.setGetFormValues) {
           props.setGetFormValues(false);
         }
         setInvalidFlag(true);
       }
    }
  }, [props.getFormValues]);

  // empty states after submit
  React.useEffect(() => {
    setState(initialStates);
    setDropdownState(dropDownsInitialStates);
  }, [props.emptyFormValues]);

  React.useEffect(() => {
    if (props.formType == "demand" || props.formType == "userAccessEdit" ||props.formType =="userCreateData") {
      if (props.demandEditData != null) {
        setState(props.demandEditData);
      }
    }
  }, []);

  return props.data.map((item, index) => {
    if (
      item.field_input_type == "Dropdown" ||
      item.field_input_type == "Related Dropdown"
    ) {
      return (
        <div className={styles.colFirst}>
          <div className={styles.row}>
            <div
              className={
                props.params === "approval"
                  ? `${styles.approvalgroup}`
                  : props.type === "user"
                  ? `${styles.userGroup}`
                  : `${styles.inputGroup}`
              }
            >
              <label>
                <span>
                  {item.field_label}
                  {props.notRequired.includes(item.field_label)?null:(item.field_required == "1" ? <sup>*</sup> : null)}
                </span>
                {/* error message */}
                {invalidFlag ? (
                  (!props.notRequired.includes(item.field_label) && ( ( state[item.value] == "" ||
                  state[item.value] == false ||
                  state[item.value] === undefined ||
                  state[item.value] == undefined||
                  state[item.value] == "undefined"||
                  state[item.value] == null) &&
                      item.field_required == "1") )? (
                    <span className={styles.errorMessage}>
                      {item.field_message_ip_error_message}
                    </span>
                  ) : null
                ) : null}
              </label>
              <p
                className={`${styles.input} ${
                  invalidFlag
                  ? (!props.notRequired.includes(item.field_label) && (( state[item.value] == "" ||
                    state[item.value] == false ||
                    state[item.value] === undefined ||
                    state[item.value] == undefined||
                    state[item.value] == "undefined"||
                    state[item.value] == null) &&
                        item.field_required == "1"))
                      ? styles.errorBorder
                      : null
                    : null
                }`}
                onClick={() => {
                  handleDropDown(item.value);
                }}
              >
                <span className={styles.left}>
                  {state[item.value] == "" ||
                  state[item.value] == null ||
                  state[item.value] == "undefined"||
                  item.field_label == "Country"
                    ? item.field_input
                    : state[item.value]}
                </span>
                <span className={styles.right}>
                  <Icons name="chevron" className={styles.chevron} />
                </span>
              </p>
              {dropDownState[item.value] == true ? (
                <div className={styles.dropdown}>
                  <DropDown
                    dropdownParent={item.value}
                    params={props.params}
                    values={
                      item.field_input_type == "Related Dropdown"
                        ? relatedDropdowns[item.value].nowValues != undefined
                          ? [
                                  // "None",
                                  ...relatedDropdowns[item.value].nowValues,
                                ]
                          : ["No parent Selected"]
                        : [
                          // "None",
                         ...item.field_options]
                    }
                  getDropdownValue={gotDropDownValue}
                  // haveRelated={camelize(item.field_related_dropdown)}
                    closeAllDropdowns={() => {
                      setDropdownState(dropDownsInitialStates);
                    }}
                  />
                </div>
              ) : null}
              {item.field_label == "Country"
                ? state[item.value].map((multipleItem, index) => (
                    <span key={index} className={styles.multipleItems}>
                      {multipleItem}
                    </span>
                  ))
                : null}
            </div>
          </div>
        </div>
      );
    } else if (item.field_input_type == "Date") {
      //  console.log(state[item.value], 'statevalue');

      return (
        <div className={styles.colFirst}>
          <div className={styles.row}>
            <div className={`${styles.inputGroup} `}>
              <label>
                <span>
                  {" "}
                  {item.field_label}{" "}
                  {item.field_required == "1" ? <sup>*</sup> : null}
                </span>
                {/* error message */}
                {invalidFlag ? (
                  ( ( state[item.value] == "" ||
                  state[item.value] == false ||
                  state[item.value] === undefined ||
                  state[item.value] == undefined||
                  state[item.value] == "undefined"||
                  state[item.value] == null) &&
                      item.field_required == "1") ? (
                    <span className={styles.errorMessage}>
                      Incorrect Format
                    </span>
                  ) : null
                ) : null}
              </label>
              <Datetime
                closeOnSelect={true}
                // initialValue={_.get(state, "dateLogged", [
                //   "2020-11-12",
                // ])}
                value={_get(state, item.value, Date.now())}
                initialValue={Date.now()}
                timeFormat={false}
                dateFormat={"DD-MM-YYYY"}
                className={`${styles.calender}  ${
                  invalidFlag
                    ? ( ( state[item.value] == "" ||
                    state[item.value] == false ||
                    state[item.value] === undefined ||
                    state[item.value] == undefined||
                    state[item.value] == "undefined"||
                    state[item.value] == null) &&
                        item.field_required == "1") 
                      ? styles.errorBorder
                      : null
                    : null
                }`}
                inputProps={inputprops}
                onChange={(date) => handleDate(date, item.value)}
              />
            </div>
          </div>
        </div>
      );
    }
  });
}

export default index;


